import axiosInstance from '../api/axios';
import type { AccessProfile, AdminPermission } from '@/types/auth';

export const accessControlService = {
  getPermissions: async (): Promise<AdminPermission[]> =>
    (await axiosInstance.get('/access-control/permissions')).data,

  getProfiles: async (): Promise<AccessProfile[]> =>
    (await axiosInstance.get('/access-control/profiles')).data,

};
